import { render } from "./logo-carousel.vue?vue&type=template&id=394f9726&scoped=true&ts=true"
import script from "./logo-carousel.vue?vue&type=script&lang=ts"
export * from "./logo-carousel.vue?vue&type=script&lang=ts"

import "./logo-carousel.vue?vue&type=style&index=0&id=394f9726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394f9726"]])

export default __exports__